import React from 'react'
import UserProfile from './UserProfile'

export default function Setting() {
    return (
        <div>
            <UserProfile/>
        </div>
    )
}
